/* ── Nav scroll ─────────────────────────────── */
const nav = document.getElementById('nav');
window.addEventListener('scroll', () => {
  nav.classList.toggle('solid', window.scrollY > 30);
}, { passive: true });

/* ── Mobile drawer ──────────────────────────── */
const burger = document.getElementById('burger');
const mob = document.getElementById('mob');
const mobClose = document.getElementById('mobClose');
burger.addEventListener('click', () => mob.classList.add('open'));
mobClose.addEventListener('click', () => mob.classList.remove('open'));
mob.querySelectorAll('.mob-link').forEach(a => {
  a.addEventListener('click', () => mob.classList.remove('open'));
});

/* ── Scroll reveal ──────────────────────────── */
const revealEls = document.querySelectorAll('.reveal');
const io = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); } });
}, { threshold: 0.12 });
revealEls.forEach(el => io.observe(el));

/* ── Ambient background (scroll driven) ─────── */
const ambient = document.getElementById('ambient');
const sections = [
  { el: document.getElementById('music'),  r:12, g:14, b:20,  ac:'rgba(184,207,224,0.06)' },
  { el: document.getElementById('disco'),  r:10, g:10, b:14,  ac:'rgba(208,208,216,0.05)' },
  { el: document.getElementById('watch'),  r:10, g:12, b:18,  ac:'rgba(184,207,224,0.08)' },
  { el: document.getElementById('merch'),  r:12, g:10, b:14,  ac:'rgba(232,191,200,0.07)' },
  { el: document.getElementById('about'),  r:12, g:10, b:16,  ac:'rgba(232,191,200,0.05)' },
];
let currentAmbient = 0;

function updateAmbient() {
  const scrollY = window.scrollY + window.innerHeight * 0.5;
  let active = null;
  sections.forEach(s => {
    if (s.el && s.el.getBoundingClientRect().top + window.scrollY <= scrollY) active = s;
  });
  if (!active) {
    document.body.style.background = 'rgb(9,9,12)';
    ambient.style.background = `radial-gradient(ellipse 80% 80% at 50% 50%, rgba(184,207,224,0.04) 0%, transparent 70%)`;
  } else {
    document.body.style.background = `rgb(${active.r},${active.g},${active.b})`;
    ambient.style.background = `radial-gradient(ellipse 80% 80% at 50% 50%, ${active.ac} 0%, transparent 70%)`;
  }
}
window.addEventListener('scroll', updateAmbient, { passive: true });
updateAmbient();

/* ── Floating particles canvas ──────────────── */
(function() {
  const canvas = document.getElementById('particles-canvas');
  const ctx = canvas.getContext('2d');
  let W, H, particles = [];
  const COLORS = ['rgba(232,191,200,', 'rgba(184,207,224,', 'rgba(208,208,216,'];

  function resize() {
    W = canvas.width = window.innerWidth;
    H = canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  class Particle {
    constructor() { this.reset(true); }
    reset(initial) {
      this.x = Math.random() * W;
      this.y = initial ? Math.random() * H : H + 10;
      this.r = Math.random() * 1.5 + 0.3;
      this.speed = Math.random() * 0.25 + 0.05;
      this.drift = (Math.random() - 0.5) * 0.2;
      this.opacity = Math.random() * 0.18 + 0.03;
      this.color = COLORS[Math.floor(Math.random() * COLORS.length)];
    }
    update() {
      this.y -= this.speed;
      this.x += this.drift;
      if (this.y < -5) this.reset(false);
    }
    draw() {
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.r, 0, Math.PI * 2);
      ctx.fillStyle = this.color + this.opacity + ')';
      ctx.fill();
    }
  }

  for (let i = 0; i < 80; i++) particles.push(new Particle());

  function loop() {
    ctx.clearRect(0, 0, W, H);
    particles.forEach(p => { p.update(); p.draw(); });
    requestAnimationFrame(loop);
  }
  loop();
})();

/* ── Chrome Orb Cursor ──────────────────────── */
(function() {
  const cursorEl   = document.getElementById('cursor');
  const orbEl      = document.getElementById('cursorOrb');
  const glowEl     = document.getElementById('cursorGlow');
  const trailEl    = document.getElementById('cursorTrail');

  if (!cursorEl) return;

  /* State */
  let mouseX = window.innerWidth / 2,  mouseY = window.innerHeight / 2;
  let orbX   = mouseX, orbY = mouseY;
  let velX   = 0,      velY = 0;

  let trailX = mouseX, trailY = mouseY;

  let scaleX = 1, scaleY = 1;
  let targetScaleX = 1, targetScaleY = 1;

  let clicking = false;
  let hovering = false;
  let onText   = false;
  let overNativeVideo = false;
  let pointerInside = true;

  /* Section-based glow color */
  const GLOW_COLORS = {
    default : 'rgba(208,208,216,0.18)',
    music   : 'rgba(184,207,224,0.22)',
    disco   : 'rgba(208,208,216,0.18)',
    watch   : 'rgba(184,207,224,0.22)',
    merch   : 'rgba(232,191,200,0.22)',
    about   : 'rgba(232,191,200,0.20)',
  };
  let currentGlow = GLOW_COLORS.default;

  /* Detect section for glow tint */
  const sectionMap = ['music','disco','watch','merch','about'];
  function updateGlowColor() {
    let active = 'default';
    const mid = window.scrollY + window.innerHeight * 0.5;
    sectionMap.forEach(id => {
      const el = document.getElementById(id);
      if (el && el.getBoundingClientRect().top + window.scrollY <= mid) active = id;
    });
    currentGlow = GLOW_COLORS[active] || GLOW_COLORS.default;
  }
  window.addEventListener('scroll', updateGlowColor, { passive: true });

  /* Raw mouse tracking */
  document.addEventListener('mousemove', e => {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  /* Magnetic targets */
  const MAGNETIC_SELECTORS = 'a, button, .disco-card, .merch-card, .stream-btn, .btn, input';
  let magTarget = null;
  let magCX = 0, magCY = 0;

  function findMagTarget(x, y) {
    const els = document.querySelectorAll(MAGNETIC_SELECTORS);
    let closest = null, closestDist = 120;
    els.forEach(el => {
      const r = el.getBoundingClientRect();
      const cx = r.left + r.width  / 2;
      const cy = r.top  + r.height / 2;
      const dx = x - cx, dy = y - cy;
      const dist = Math.sqrt(dx*dx + dy*dy);
      if (dist < closestDist) { closestDist = dist; closest = el; magCX = cx; magCY = cy; }
    });
    return closest;
  }

  /* Hover / text detection */
  document.addEventListener('mouseover', e => {
    const t = e.target;
    hovering = !overNativeVideo && !!(t.closest('a, button, .disco-card, .watch-card, .merch-card, .stream-btn, .btn'));
    onText   = !hovering && (t.tagName === 'P' || t.tagName === 'SPAN' || t.tagName === 'H1' || t.tagName === 'H2' || t.tagName === 'H3');
  });

  /* Click compression */
  document.addEventListener('mousedown', () => { clicking = true; });
  document.addEventListener('mouseup',   () => { clicking = false; });

  /* Hide when leaving window */
  document.addEventListener('mouseleave', () => { pointerInside = false; cursorEl.style.opacity = '0'; trailEl.style.opacity = '0'; });
  document.addEventListener('mouseenter', () => { pointerInside = true; });

  /* RAF loop */
  function tick() {
    const hitEl = document.elementFromPoint(mouseX, mouseY);
    overNativeVideo = !!(hitEl && hitEl.closest('.watch-embed, .watch-video, iframe, video'));

    /* Magnetic pull */
    magTarget = findMagTarget(mouseX, mouseY);
    let targetX = mouseX, targetY = mouseY;
    if (magTarget) {
      const r   = magTarget.getBoundingClientRect();
      const cx  = r.left + r.width  / 2;
      const cy  = r.top  + r.height / 2;
      const dx  = cx - mouseX, dy = cy - mouseY;
      const dist = Math.sqrt(dx*dx + dy*dy);
      const strength = dist < 40 ? 0.22 : 0.10;
      targetX = mouseX + dx * strength;
      targetY = mouseY + dy * strength;
    }

    /* Spring physics */
    velX += (targetX - orbX) * 0.10;
    velY += (targetY - orbY) * 0.10;
    velX *= 0.72;
    velY *= 0.72;
    orbX += velX;
    orbY += velY;

    /* Trail (slower lerp) */
    trailX += (orbX - trailX) * 0.10;
    trailY += (orbY - trailY) * 0.10;

    /* Speed for squash/stretch */
    const speed = Math.sqrt(velX*velX + velY*velY);
    const dir   = speed > 0.01 ? { x: velX / speed, y: velY / speed } : { x: 1, y: 0 };

    /* Target scale */
    if (clicking) {
      targetScaleX = 0.85; targetScaleY = 0.85;
    } else if (hovering) {
      const sq = Math.min(speed * 0.025, 0.25);
      targetScaleX = 1.55 + sq;
      targetScaleY = 1.55 - sq * 0.5;
    } else if (onText) {
      targetScaleX = 0.7; targetScaleY = 0.7;
    } else {
      const sq = Math.min(speed * 0.018, 0.18);
      targetScaleX = 1.0 + sq;
      targetScaleY = 1.0 - sq * 0.6;
    }

    /* Lerp scale */
    const sf = clicking ? 0.22 : 0.12;
    scaleX += (targetScaleX - scaleX) * sf;
    scaleY += (targetScaleY - scaleY) * sf;

    /* Hide the custom cursor over embedded/native video controls so browser/player cursors do not double up. */
    const customCursorOpacity = pointerInside && !overNativeVideo ? 1 : 0;
    cursorEl.style.opacity = customCursorOpacity.toString();
    trailEl.style.opacity = overNativeVideo ? '0' : trailEl.style.opacity;

    /* Glow intensity from speed */
    const glowScale = 1 + Math.min(speed * 0.04, 0.8);
    const glowOpacity = hovering ? 0.32 : onText ? 0.08 : Math.min(0.18 + speed * 0.012, 0.30);

    /* Apply transforms (GPU path) */
    cursorEl.style.transform = `translate3d(${orbX}px, ${orbY}px, 0)`;
    orbEl.style.transform    = `translate(-50%,-50%) scale(${scaleX.toFixed(3)},${scaleY.toFixed(3)})`;
    glowEl.style.transform   = `translate(-50%,-50%) scale(${glowScale.toFixed(3)})`;
    glowEl.style.background  = `radial-gradient(circle, ${currentGlow.replace(/[\d.]+\)$/, v => glowOpacity.toFixed(2)+')')} 0%, transparent 70%)`;

    /* Trail */
    trailEl.style.transform  = `translate3d(${trailX - 9}px, ${trailY - 9}px, 0)`;
    trailEl.style.opacity    = overNativeVideo ? '0' : Math.min(speed * 0.022, 0.045).toFixed(3);

    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  /* Post-click bounce */
  document.addEventListener('mouseup', () => {
    setTimeout(() => { targetScaleX = 1.1; targetScaleY = 1.1; }, 80);
    setTimeout(() => { targetScaleX = 1.0; targetScaleY = 1.0; }, 240);
  });
})();

/* ── Three.js Chrome Orb ────────────────────── */
(function() {
  if (!window.THREE) return;

  const canvas = document.getElementById('orb-canvas');
  const heroSection = document.querySelector('.hero');
  if (!canvas || !heroSection) return;

  const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.2;

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(50, window.innerWidth / window.innerHeight, 0.1, 100);
  camera.position.set(0, 0, 5);

  /* Environment (fake IBL using a gradient sphere) */
  const envGeo = new THREE.SphereGeometry(40, 32, 32);
  const envMat = new THREE.MeshBasicMaterial({
    side: THREE.BackSide,
    color: 0x090912
  });
  scene.add(new THREE.Mesh(envGeo, envMat));

  /* Lights that give the chrome effect */
  const aLight = new THREE.AmbientLight(0xb8cfe0, 0.4);
  scene.add(aLight);

  const pLight1 = new THREE.PointLight(0xe8bfc8, 3.5, 20);
  pLight1.position.set(3, 4, 3);
  scene.add(pLight1);

  const pLight2 = new THREE.PointLight(0xb8cfe0, 2.5, 20);
  pLight2.position.set(-4, -2, 2);
  scene.add(pLight2);

  const pLight3 = new THREE.PointLight(0xffffff, 1.5, 20);
  pLight3.position.set(0, -4, 4);
  scene.add(pLight3);

  /* Orb geometry — distorted sphere for liquid mercury look */
  const geo = new THREE.SphereGeometry(1.5, 128, 128);

  /* Displace vertices for organic shape */
  const pos = geo.attributes.position;
  const origPos = new Float32Array(pos.array);
  const noise = (x, y, z) => {
    /* simple 3D value noise approximation */
    const sx = Math.sin(x * 2.1 + 1.3) * Math.cos(y * 1.8 + 0.7) * 0.5;
    const sy = Math.sin(y * 2.4 + 2.1) * Math.cos(z * 1.6 + 1.2) * 0.5;
    const sz = Math.sin(z * 1.9 + 0.8) * Math.cos(x * 2.2 + 1.5) * 0.5;
    return (sx + sy + sz) / 3;
  };

  /* Store original positions for animation */
  const origPosArr = [];
  for (let i = 0; i < pos.count; i++) {
    origPosArr.push(pos.getX(i), pos.getY(i), pos.getZ(i));
  }

  const mat = new THREE.MeshStandardMaterial({
    color: 0xc8c8d8,
    metalness: 0.98,
    roughness: 0.04,
    envMapIntensity: 1.0,
  });

  const orb = new THREE.Mesh(geo, mat);
  scene.add(orb);

  /* Mouse tracking */
  const mouse = { x: 0, y: 0, tx: 0, ty: 0 };
  document.addEventListener('mousemove', e => {
    mouse.tx = (e.clientX / window.innerWidth - 0.5) * 2;
    mouse.ty = -(e.clientY / window.innerHeight - 0.5) * 2;
  });

  /* Touch support */
  document.addEventListener('touchmove', e => {
    const t = e.touches[0];
    mouse.tx = (t.clientX / window.innerWidth - 0.5) * 2;
    mouse.ty = -(t.clientY / window.innerHeight - 0.5) * 2;
  }, { passive: true });

  /* Resize */
  window.addEventListener('resize', () => {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
  });

  /* Only show orb when hero is visible */
  let heroVisible = true;
  const heroObs = new IntersectionObserver(entries => {
    heroVisible = entries[0].isIntersecting;
  }, { threshold: 0 });
  heroObs.observe(heroSection);

  const clock = new THREE.Clock();

  function animate() {
    requestAnimationFrame(animate);
    if (!heroVisible) return;

    const t = clock.getElapsedTime();

    /* Smooth mouse follow */
    mouse.x += (mouse.tx - mouse.x) * 0.04;
    mouse.y += (mouse.ty - mouse.y) * 0.04;

    /* Orb tilt based on mouse */
    orb.rotation.x += (mouse.y * 0.3 - orb.rotation.x) * 0.05;
    orb.rotation.y += (mouse.x * 0.3 - orb.rotation.y) * 0.05;
    orb.rotation.z += 0.001;

    /* Organic pulsing deformation */
    const posAttr = geo.attributes.position;
    for (let i = 0; i < posAttr.count; i++) {
      const ox = origPosArr[i * 3];
      const oy = origPosArr[i * 3 + 1];
      const oz = origPosArr[i * 3 + 2];

      const len = Math.sqrt(ox*ox + oy*oy + oz*oz);
      const nx = ox / len; const ny = oy / len; const nz = oz / len;

      const displacement =
        Math.sin(nx * 3.0 + t * 0.7) * 0.06 +
        Math.sin(ny * 2.5 + t * 0.9 + 1.0) * 0.055 +
        Math.sin(nz * 3.5 + t * 0.8 + 2.0) * 0.05 +
        mouse.x * ny * 0.08 +
        mouse.y * nz * 0.08;

      posAttr.setXYZ(i,
        ox + nx * displacement,
        oy + ny * displacement,
        oz + nz * displacement
      );
    }
    posAttr.needsUpdate = true;
    geo.computeVertexNormals();

    /* Light orbit */
    pLight1.position.x = Math.sin(t * 0.4) * 4 + mouse.x * 1.5;
    pLight1.position.y = Math.cos(t * 0.3) * 3 + mouse.y * 1.5;
    pLight2.position.x = Math.cos(t * 0.5 + 1) * 3;
    pLight2.position.y = Math.sin(t * 0.4 + 2) * 3;

    /* Gentle float */
    orb.position.y = Math.sin(t * 0.5) * 0.08;

    renderer.render(scene, camera);
  }

  animate();
})();
